// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-scroll-element__afOIJ {
  position: relative;
}
.drag-scroll-element__afOIJ .curtain__US4l3 {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

.grab__qVRw3 {
  cursor: grab;
}

.grabbing__ZhntO {
  cursor: grabbing;
  user-select: none;
}

.horizontal__pHIqq {
  overflow-x: auto;
  overflow-y: hidden;
  touch-action: pan-y;
}

.vertical__kpTUb {
  overflow-y: auto;
  overflow-x: hidden;
  touch-action: pan-x;
}

.hide-scrollbar__yljd9::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar__yljd9 {
  -ms-overflow-style: none;
  scrollbar-width: none;
}`, "",{"version":3,"sources":["webpack://./src/components/drag-scroll/drag-scroll.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AACJ;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,kBAAA;EAEA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,kBAAA;EAEA,mBAAA;AAFF;;AAME;EACE,aAAA;AAHJ;AACA;EAKE,wBAAA;EACA,qBAAA;AAHF","sourcesContent":[".drag-scroll-element {\n  position: relative;\n\n  .curtain {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 9999;\n  }\n}\n\n.grab {\n  cursor: grab;\n}\n\n.grabbing {\n  cursor: grabbing;\n  user-select: none;\n}\n\n.horizontal {\n  overflow-x: auto;\n  overflow-y: hidden;\n  // Reserve vertical panning for native page scroll; horizontal panning is handled in JS.\n  touch-action: pan-y;\n}\n\n.vertical {\n  overflow-y: auto;\n  overflow-x: hidden;\n  // Reserve horizontal panning for native page scroll; vertical panning is handled in JS.\n  touch-action: pan-x;\n}\n\n.hide-scrollbar {\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drag-scroll-element": `drag-scroll-element__afOIJ`,
	"curtain": `curtain__US4l3`,
	"grab": `grab__qVRw3`,
	"grabbing": `grabbing__ZhntO`,
	"horizontal": `horizontal__pHIqq`,
	"vertical": `vertical__kpTUb`,
	"hide-scrollbar": `hide-scrollbar__yljd9`
};
export default ___CSS_LOADER_EXPORT___;
